//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

import customActionTemplate from '@legacy-components/common/universal-image-actions/custom-action.html';

(function() {
  const curalate = angular.module('curalate');

  curalate.directive('customAction', [
    'TrackingService',
    'UniversalImageActionsHelpers',
    function(
            TrackingService,
            UniversalImageActionsHelpers,
        ) {
      return {
        restrict: 'E',
        scope: {
          name: '@',
        },
        replace: true,
        transclude: true,
        require: '^universalImageActions',
        template: customActionTemplate,
        link(scope, attrs, ele, uiaController) {
          const TRACKING_CATEGORY = UniversalImageActionsHelpers.getTrackingCategory(uiaController.getPage());

          scope.model = {
            trackCustomAction() {
              TrackingService.recordEvent(TRACKING_CATEGORY, scope.name);

              return true;
            },
          };
        },
      };
    },
  ]);
})();
